import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quiz-personal-stage-passions__chips" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Continue")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppChip = _resolveComponent("AppChip")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_QuizCard = _resolveComponent("QuizCard")!

  return (_openBlock(), _createBlock(_component_QuizCard, {
    title: "❤️‍🔥 Passions",
    description: "What you love to talk about, think about, share with others.",
    class: "quiz-personal-stage-passions",
    "onQuizNavigation:back": _ctx.navigatePrev,
    "onQuizNavigation:close": _cache[2] || (_cache[2] = ($event: any) => (_ctx.QuizService.close()))
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_AppButton, {
        onClick: _ctx.navigateNext,
        loading: _ctx.QuizService.isSaving()
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_AppInput, {
        id: "quiz-personal-stage-passions-input",
        modelValue: _ctx.localPassion,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localPassion) = $event)),
        label: "Passions",
        type: "text",
        placeholder: "Type to add",
        onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.savePassion(_ctx.localPassion)), ["enter"])),
        autofocus: ""
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPassions, (passion, index) => {
          return (_openBlock(), _createBlock(_component_AppChip, {
            text: passion,
            divider: true,
            key: index,
            onOnRemove: ($event: any) => (_ctx.removePassion(passion))
          }, null, 8, ["text", "onOnRemove"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["onQuizNavigation:back"]))
}